/**
 * Copy link to clipboard functionality
 */
 projectFunctions.shareCopyFunctions = projectFunctions.shareCopyFunctions || {};

 /**
  * Init: Will be triggered on document ready.
  */
 projectFunctions.shareCopyFunctions.init = function() {
     this.shareCopy();
 };
 
 projectFunctions.shareCopyFunctions.shareCopy = function () {
  if ($('.share-copy').length) {
    $('.share-copy').on('click', function(e) {
      e.preventDefault();
      
      const url = window.location.href;
      
      // Modern approach using Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
    });
  }
};

